export const EMPLOYEE_ENGAGEMENT_TYPES = {
  FULL_TIME: 'FT',
  PART_TIME: 'PT',
  OVERTIME: 'OT',
  FULL_TIME_AUGMENTED: 'FTA',
  AD_HOC: 'AH',
};

export const getEngagementTypeName = (scope) => {
  switch (scope) {
      case EMPLOYEE_ENGAGEMENT_TYPES.FULL_TIME:
          return 'Full Time';
      case EMPLOYEE_ENGAGEMENT_TYPES.PART_TIME:
          return 'Part Time';
      case EMPLOYEE_ENGAGEMENT_TYPES.OVERTIME:
          return 'Overtime';
      case EMPLOYEE_ENGAGEMENT_TYPES.FULL_TIME_AUGMENTED:
          return 'Full Time Augmented';
      case EMPLOYEE_ENGAGEMENT_TYPES.AD_HOC:
          return 'Ad Hoc';
      default:
          return scope;
  }
};